<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 42 42"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      opacity="0.4"
      d="M28.3332 20.9809H13.6665M20.9998 13.6545V28.3073V13.6545Z"
      stroke="#359652"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M30.3714 1H11.6286C5.09524 1 1 5.62417 1 12.1703V29.8297C1 36.3758 5.07619 41 11.6286 41H30.3714C36.9238 41 41 36.3758 41 29.8297V12.1703C41 5.62417 36.9238 1 30.3714 1Z"
      stroke="#359652"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>

<script>
export default {
  name: 'PlusIcon',
  props: ['size'],
};
</script>

<style scoped>

</style>
